import { ChangeDetectionStrategy, Component, computed, inject, input, output, ViewEncapsulation } from '@angular/core';
import { IFileUploadData } from '@fi-shared/fi-insert-media/fi-file-upload-d';
import { FiFileUploadState } from '@fi-shared/fi-insert-media/fi-file-upload-enums';
import { fiGetMediaBankFileIconAwesome } from '@fi-shared/utils';
import { FileType } from '@fi-shared/types';
import { MediaBankHelperService } from '@fi-shared/media-bank/media-bank-helper.service';

@Component({
    selector: 'fi-file-upload-progress',
    templateUrl: './fi-file-upload-progress.component.html',
    styleUrl: './fi-file-upload-progress.component.scss',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'fi-file-upload-progress' },
    standalone: false,
})
export class FiFileUploadProgressComponent {
    fileUploadData = input.required<IFileUploadData>();

    cancelUpload = output<void>();
    clearUploadData = output<void>();
    retryUpload = output<void>();

    private fiMediaBankHelperService = inject(MediaBankHelperService);

    private fileUploadState = computed<FiFileUploadState>(() => {
        return this.fileUploadData().state;
    });

    protected fileIconClass = computed<string>(() => {
        if (!this.fileUploadData()) return '';

        const iconClass = fiGetMediaBankFileIconAwesome(FileType.Excel);
        return 'fa-regular ' + iconClass;
    });

    protected fileSize = computed<string>(() => {
        return this.fiMediaBankHelperService.getFileSizeText(this.fileUploadData()?.size);
    });

    protected isCancelUploadAvailable() {
        return this.fileUploadState() === FiFileUploadState.InProgress;
    }

    protected isClearUploadDataAvailable() {
        const state = this.fileUploadState();
        return state === FiFileUploadState.Completed || state === FiFileUploadState.Failed;
    }

    protected isRetryUploadAvailable() {
        return this.fileUploadState() === FiFileUploadState.Failed;
    }

    protected onCancelUploadClick() {
        this.cancelUpload.emit();
    }

    protected onClearUploadDataClick() {
        this.clearUploadData.emit();
    }

    protected onRetryUploadClick() {
        this.retryUpload.emit();
    }

    protected showProgressBar() {
        return this.fileUploadState() === FiFileUploadState.InProgress;
    }

    protected showErrorMessage() {
        return this.fileUploadState() === FiFileUploadState.Failed;
    }
    protected isDoneIconShown() {
        return this.fileUploadState() === FiFileUploadState.Completed;
    }
}
